import { render, staticRenderFns } from "./TableHeaderColumn.vue?vue&type=template&id=5b4275e0"
import script from "./TableHeaderColumn.vue?vue&type=script&lang=js"
export * from "./TableHeaderColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports